import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { ObjectIdentifierKey } from 'cio/utils/identifiers';
import LogModel from 'cio/models/log';
import ObjectModel from 'cio/models/object';
import DS from 'ember-data';
import { hasMany } from '@ember-data/model';
import SqlImportModel from 'cio/models/sql-import';
import { isEmpty } from '@ember/utils';

export interface ObjectTypeUsage {
  apitbCount: number;
  campaignCount: number;
  newsletterCount: number;
  segmentCount: number;
  snippetCount: number;
}

export default class ObjectTypeModel extends Model {
  @attr('string') color!: string;
  @attr('boolean') enabled!: boolean;
  @attr('string') icon!: string;
  @attr('boolean') moreAttributes!: boolean;
  @attr('boolean') moreRelAttributes!: boolean;
  @attr('string', { defaultValue: '' }) name!: string;
  @attr() sentAttributes!: (ObjectIdentifierKey | string)[];
  @attr() sentRelAttributes!: string[];
  @attr('string') singularName!: string;
  @attr('string') slug!: string;
  @attr('string') singularSlug!: string;
  @attr('boolean') hasNonUiObjects!: boolean;
  @attr('number') objectCount!: number;
  @attr('camel-case', { defaultValue: () => ({}) }) usage!: ObjectTypeUsage;

  @hasMany('log', { async: false, inverse: 'objectType' }) logs!: DS.ManyArray<LogModel>;
  @hasMany('object', { async: false, inverse: 'objectType' }) objects!: DS.ManyArray<ObjectModel>;
  @hasMany('sql-import', { async: false, inverse: 'objectType' }) sqlImport!: SqlImportModel;

  get objectIcon() {
    return isEmpty(this.icon) ? 'object' : this.icon;
  }

  // used to temporary update sentAttributes when creating a new object with new attribute
  updateSentAttributes(attributes: Record<string, any>) {
    let attrs = [...(this.sentAttributes ?? [])];
    for (let key in attributes) {
      if (!attrs.includes(key)) {
        attrs.push(key);
      }
    }

    this.set('sentAttributes', attrs);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'object-type': ObjectTypeModel;
  }
}
